import {
  CalendarFilledIcon,
  CalendarIcon,
  LibraryFilledIcon,
  LibraryIcon,
  SearchFilledIcon,
  SearchIcon,
  UpNextFilledIcon,
  UpNextIcon,
} from "@/components/Icon";

export const TABS = ["upnext", "upcoming", "library", "search"] as const;
export type Tab = (typeof TABS)[number];

const LABELS: Record<Tab, string> = {
  upnext: "Up Next",
  upcoming: "Upcoming",
  library: "Library",
  search: "Search",
};

type IconComponent = (props: { className?: string }) => React.ReactElement;

/* Selected tabs use the filled glyph, as iOS does: the fill carries selection
 * on its own, so it still reads at a glance without relying on colour. */
const ICONS: Record<Tab, { outline: IconComponent; filled: IconComponent }> = {
  upnext: { outline: UpNextIcon, filled: UpNextFilledIcon },
  upcoming: { outline: CalendarIcon, filled: CalendarFilledIcon },
  library: { outline: LibraryIcon, filled: LibraryFilledIcon },
  search: { outline: SearchIcon, filled: SearchFilledIcon },
};

interface Props {
  active: Tab;
  onSelect: (tab: Tab) => void;
}

export function TabBar({ active, onSelect }: Props) {
  return (
    <nav className="tabbar" aria-label="Sections">
      {TABS.map((tab) => {
        const selected = tab === active;
        const Icon = selected ? ICONS[tab].filled : ICONS[tab].outline;
        return (
          <button
            key={tab}
            type="button"
            className="tab"
            aria-selected={selected}
            onClick={() => {
              onSelect(tab);
            }}
          >
            <Icon />
            <span>{LABELS[tab]}</span>
          </button>
        );
      })}
    </nav>
  );
}
